import React, { useEffect, useState } from "react";
import { Avatar, Grid, Stack, Typography } from "@mui/material";
import CardComponent from "../../../components/Card";
import { useSelector } from "react-redux";
import { postRequest } from "../../../services/api";
import totalASN from "assets/total_asn.svg";
import totalVerifiedClosedASN from "assets/asn_verified_closed.svg";
import totalItemsRcvd from "assets/asn_item_recieved.svg";
import totalPiecesRcvd from "assets/asn_pieces_recieved.svg";

const ContainerCount = () => {
  const { startDate, endDate } = useSelector((state) => state.dashboard);
  const { user, userSetting } = useSelector((state) => state.user);
  const [asnCount, setAsnCount] = useState([]);

  const Icon = (props) => {
    return <img src={props.icon} alt={props.icon} width="25" />;
  };

  const formatAsnCount = (data) => {
    let mappedObj = {
      totalInvoices: { label: "Total Invoices", icon: totalASN },
      totalPaidAmt: {
        label: "Amount Paid",
        icon: totalVerifiedClosedASN,
      },
      openInvoices: {
        label: "Open Invoices",
        icon: totalItemsRcvd,
      },
      totalDue: {
        label: "Total Dues",
        icon: totalPiecesRcvd,
      },
    };
    const formatData = Object.keys(mappedObj).map((item) => {
      let sumData;
      
      sumData = data && data.length > 0 && data.reduce((acc, obj) => {
        acc += parseFloat(obj[item]);
        return acc;
      })
      
      
      return {
        label: mappedObj[item]["label"],
        value: sumData && sumData[item] ? sumData[item] : 0,
        icon: mappedObj[item]["icon"],
      };
    });

    setAsnCount(formatData);
  };

  const fetchAsnCount = async () => {
    let headers = {
      "Content-Type": "application/json;",
      Authorization: `Bearer ${user.token}`,
    };
    let payload = {
      custCode: userSetting[0].currCustomer,
      whseCode: userSetting[0].currWarehouse,
      fromDate: startDate.format("YYYY-MM-DD"),
      toDate: endDate.format("YYYY-MM-DD"),
    };
    const response = await postRequest(
      "user/getDashCounts_invoices",
      payload,
      headers
    );
    formatAsnCount(response.data.Payload);
  };

  useEffect(() => {
    fetchAsnCount();
  }, [startDate, endDate, userSetting]);

  return asnCount.map((item, index) => (
    <Grid item xs={3} key={index}>
      <CardComponent>
        <Stack direction="row" spacing={2}>
          <Avatar sx={{ bgcolor: "#eceaf9", width: 50, height: 50 }}>
            <Icon icon={item.icon} />
          </Avatar>
          <div className="card-title-wrap">
            <Typography variant="subtitle1" gutterBottom>
              {item.label}
            </Typography>
            <Typography variant="h5" component="p" sx={{ fontWeight: 700 }}>
              {item.value}
            </Typography>
          </div>
        </Stack>
      </CardComponent>
    </Grid>
  ));
};

export default ContainerCount;
